module.exports = __webpack_public_path__ + "static/media/movies-2.a806e957.png";